/* eslint-disable max-classes-per-file */
export class SearchByTerm {
  static readonly type = '[Search] Search By Term';
  constructor(public searchTerm?: string) {}
}

export class ResetSearch {
  static readonly type = '[Search] Reset Search';
}
